"use client";

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../../../../../components/navbar.jsx";
import Footer from "../../../../../components/footer.jsx";
import PaymentCompleteModal from "../../../components/PaymentCompleteModal.jsx";
import PrintReceiptDialog from "../../../../../components/print/views/PrintReceiptDialog";
import styles from "../css/creditProfiles.module.css";

export default function CreditBalanceCompleteView() {
  const location = useLocation();
  const navigate = useNavigate();

  const recieptno = location.state?.recieptno ? String(location.state.recieptno) : "";
  const [printOpen, setPrintOpen] = useState(false);

  const amountPaid = typeof location.state?.amountPaid === "number" ? location.state.amountPaid : 0;

  useEffect(() => {
    if (recieptno) setPrintOpen(true);
  }, [recieptno]);

  return (
    <div className={styles.wrapper}>
      <Navbar onBack={() => navigate("/frontshop/payment-types/credit", { state: location.state })} />
      <main className={styles.main}>
        <div className={styles.balanceOverlay}>
          <div className={styles.balanceModalInner}>
            <PaymentCompleteModal
              amountPaid={amountPaid}
              paymentMethod="Credit"
              discountApplied={0}
              onNewSale={() => navigate("/frontshop", { state: location.state })}
              onClose={() => navigate("/frontshop", { state: location.state })}
              title="Payment Complete!"
              subtitle="Credit payment processed successfully"
              amountLabel="Amount Paid"
              methodLabel="Payment Method"
              discountLabel="Discount Applied"
              primaryLabel="Close"
              showDiscount={false}
            />

            <PrintReceiptDialog
              open={printOpen}
              recieptno={recieptno}
              onClose={() => setPrintOpen(false)}
            />
          </div>
        </div>
      </main>
      <div className={styles.footerWrapper}>
        <Footer />
      </div>
    </div>
  );
}
